// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TopCategory{margin-bottom:0;text-align:center;transform:translateZ(0)}.TopCategory__image{margin-bottom:.5rem}.TopCategory__title{font-weight:700;margin-bottom:.5rem}.TopCategory--hasLinks>.TopCategory__title{margin-bottom:1rem}.TopCategory__linksItem{color:#243a88;text-decoration:inherit}.TopCategory__linksItem:focus,.TopCategory__linksItem:hover{color:#14204c;text-decoration:inherit}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
